export default {"src":"/_next/static/media/mail.0e893716.svg","height":132,"width":132,"blurWidth":0,"blurHeight":0};